import { render, staticRenderFns } from "./FrzPackingSealersBag.vue?vue&type=template&id=db24afca"
import script from "./FrzPackingSealersBag.vue?vue&type=script&lang=js"
export * from "./FrzPackingSealersBag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports